var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-2",attrs:{"min-width":"0","text":"","to":"/inicio","exact":""}},[_c('v-icon',[_vm._v("mdi-view-dashboard")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }